var _excluded = ["content", "activeIndex"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled, { css } from "styled-components";
import fadeInSlideIn from "../../../animations/fadeInSlideIn";
import space from "../../../utils/space";
export var defaultProps = {
  activeIndex: 0
};
var Wrapper = styled.div.withConfig({
  componentId: "sc-1wgrooy-0"
})(["display:grid;"]);
var Item = styled.div.withConfig({
  componentId: "sc-1wgrooy-1"
})(function (_ref) {
  var $isVisible = _ref.$isVisible;
  return css(["display:flex;grid-area:1 / 1 / 2 / 2;align-items:center;justify-content:center;opacity:0;", ""], $isVisible && css(["animation:", " 800ms;animation-fill-mode:forwards;"], fadeInSlideIn(space(2))));
});
function ContentToggleMol(_ref2) {
  var content = _ref2.content,
    _ref2$activeIndex = _ref2.activeIndex,
    activeIndex = _ref2$activeIndex === void 0 ? defaultProps.activeIndex : _ref2$activeIndex,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(Wrapper, restProps, content.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Item, {
      $isVisible: index === activeIndex,
      key: "content-".concat(index + 1)
    }, item);
  }));
}
export default ContentToggleMol;